import invitationLinks from './invitationLinks';

export default invitationLinks;
